import React from 'react'
import CustomButton from '@/components/CustomButton'

interface SuccessStepProps {
  title?: string
  subtitle?: string
  buttonText?: string
  onButtonClick: () => void
}

const SuccessStep: React.FC<SuccessStepProps> = ({
  title = "",
  subtitle = "",
  buttonText = "",
  onButtonClick
}) => {
  return (
    <div className="text-center pt-6">
      <img src="/icon/kyc-status-icon.svg" />
      <div className="my-8">
        <div className="mb-2 text-3.75 text-black font-bold">{title}</div>
        <div className='text-3.75 text-black'>{subtitle}</div>
      </div>
      <div className="my-8">
        <CustomButton
          onClick={onButtonClick}
        >
          {buttonText}
        </CustomButton>
      </div>
    </div>
  )
}

export default SuccessStep